import { RailsSwapDetail } from '@sls-react/typings/services/rails/swaps';
import fetcher, { makeFetcher } from '@sls-react/api/fetcher';

export const printLabel = (swapId: number, returnLabel?: boolean) =>
  fetcher<RailsSwapDetail>(
    returnLabel
      ? `/v2/swaps/${swapId}/dispute/print_label`
      : `/v1/swaps/${swapId}/print_label`,
    {
      method: 'put',
    },
  );

export const fetchBadgeCount = makeFetcher<{ badge: number }, []>(
  () => '/v1/swaps/badge',
);

export const postCreateSwap = makeFetcher<
  RailsSwapDetail,
  [
    itemId: number | string,
    price?: number | string, // Required for backend offer validation to work
    selectedVariationId?: string | number,
  ]
>(
  (
    itemId: number | string,
    price: number | string,
    selectedVariationId?: string | number,
  ) => [
    '/v1/swaps',
    {
      body: {
        swap: {
          item_id: itemId,
          offer: {
            amount: +price || undefined,
            item_variation_id: selectedVariationId,
          },
        },
      },
      method: 'post',
    },
  ],
);

export const fetchSwapById = makeFetcher<RailsSwapDetail, [number]>(
  (swapId: number) => `/v1/swaps/${swapId}`,
);
